import { render, staticRenderFns } from "./PopupAddTask.vue?vue&type=template&id=66534fe1&"
import script from "./PopupAddTask.vue?vue&type=script&lang=js&"
export * from "./PopupAddTask.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddTask.vue?vue&type=style&index=0&id=66534fe1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports